'use client';

import {
  FreeSoloPopover as HeroUiFreeSoloPopover,
  Popover as HeroUiPopover,
  PopoverContent as HeroUiPopoverContent,
  PopoverTrigger as HeroUiPopoverTrigger,
  type PopoverContentProps,
  PopoverProvider,
  usePopover,
  usePopoverContext,
} from '@heroui/popover';
import { cn } from '@/utils';

export const Popover = HeroUiPopover;
export const PopoverTrigger = HeroUiPopoverTrigger;

export const PopoverContent = ({ className, ...props }: PopoverContentProps) => (
  <HeroUiPopoverContent {...props} className={cn('!rounded-2xl', className)} />
);

export const FreeSoloPopover = HeroUiFreeSoloPopover;
export { PopoverProvider, usePopover, usePopoverContext };
